export default {
  name: 'errors',
  state: {},
  reducers: {
    add(state, { realm, type, error = true }) {
      return {
        ...state,
        [realm]: {
          ...state[realm],
          [type]: error,
        },
      };
    },
    remove(state, { realm, type }) {
      const err = { ...state };
      if (err[realm] && err[realm][type]) delete err[realm][type];
      if (err[realm] && Object.keys(err[realm]).length === 0) delete err[realm];
      return err;
    },
    clear() {
      return {};
    },
  },
};
